import React, { useCallback } from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import {
  getFormQuestionAttributeAnswerOptionsListId,
  getFormQuestionPrompt,
  setQuestionAttributeAnswerOptionsListId,
  setQuestionAttributeOptions,
} from "reduxSlices/formBuilderSlice"
import { answerOptionsLists as selectAnswerOptionsLists } from "reduxSlices/answerOptionsListsSlice"
import { ListSelect } from "shared/selects"
import AnswerOptionsListSelectedValidation from "./SelectOptionsValidations/AnswerOptionsListSelectedValidation"

const optionsFromAnswerOptionsLists = (lists) => lists.map(({ id, name }) => ({ label: name, value: id }))

const AnswerOptionsListSelect = ({ questionIndex, sectionIndex }) => {
  const dispatch = useDispatch()

  const answerOptionsLists = useSelector(selectAnswerOptionsLists, isEqual)
  const questionPrompt = useSelector(getFormQuestionPrompt({ sectionIndex, questionIndex }))
  const answerOptionsListId = useSelector(
    getFormQuestionAttributeAnswerOptionsListId({ sectionIndex, questionIndex }),
  )

  const updateAnswerOptionsList = useCallback((newAnswerOptionsListId) => {
    const selectedList = answerOptionsLists.find(({ id }) => id === newAnswerOptionsListId)

    dispatch(setQuestionAttributeAnswerOptionsListId({
      sectionIndex, questionIndex, newAnswerOptionsListId,
    }))
    dispatch(setQuestionAttributeOptions({
      sectionIndex, questionIndex, newOptions: selectedList?.options ?? [],
    }))
  }, [answerOptionsLists, dispatch, sectionIndex, questionIndex])

  return (
    <div className="flex-center mb-4">
      <div className="font-medium">List</div>
      <div>
        <ListSelect
          options={answerOptionsLists}
          optionsFromList={optionsFromAnswerOptionsLists}
          value={answerOptionsListId}
          onChange={updateAnswerOptionsList}
          clearable={Boolean(answerOptionsListId)}
          placeholder="Select Answer Options List"
          label={`select answer options list for question ${questionPrompt}`}
        />
        <AnswerOptionsListSelectedValidation
          value={answerOptionsListId}
          sectionIndex={sectionIndex}
          questionIndex={questionIndex}
        />
      </div>
    </div>
  )
}

AnswerOptionsListSelect.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default AnswerOptionsListSelect
